






















































































































































import { Component, Vue } from 'vue-property-decorator';
import checkout from '@/store/modules/checkout';
import { AddressAttributeObject, QuoteAddress } from '@/store/models';
import Datepicker from 'vuejs-datepicker';
import store from '@/store';
import getValidationRules from '@/commons/formFieldValidationRules';
import { initState } from '@/store/stateinit';
import cart from '@/store/modules/cart';

@Component({
    components: {
        Datepicker,
    },
})
export default class RequestInvoice extends Vue {
    public addressAttributes: AddressAttributeObject = initState('addressAttributes');
    private loading = false;

    get requestInvoice(): boolean {
        return checkout.requestInvoice.requested;
    }

    set requestInvoice(val: boolean) {
        checkout.updateRequestInvoice({ flag: val });
    }

    get novatRequested(): number {
        return checkout.requestInvoice.novatrequested;
    }

    set novatRequested(val: number) {
        checkout.updateRequestInvoice({ flag: this.requestInvoice, params: { novatrequested: val } });
    }

    get hasNoVatFlag(): boolean {
        if (!store.state.options.requestinvoice.novat_flag) {
            return false;
        }
        if (store.state.options.requestinvoice.novat_countries === '') {
            return true;
        }
        return store.state.options.requestinvoice.novat_countries
            .split(',')
            .includes(checkout.billingAddress.country_id);
    }

    get companyNameLabel(): any {
        if (this.hasNoVatFlag && this.novatRequested === 2) {
            return this.$t('Name des Unternehmens oder des Inhabers');
        }
        return this.$t('Company Name');
    }

    get vatLabel(): any {
        if (this.hasNoVatFlag && this.novatRequested === 2) {
            return this.$t('Nummer der Gewerbeanmeldung/Steuernummer');
        }
        return this.$t('VAT Number');
    }

    get companyNamePlaceholderLabel(): any {
        if (this.hasNoVatFlag && this.novatRequested === 2) {
            return this.$t('Name des Unternehmens oder des Inhabers');
        }
        return this.$t('Enter Company Name');
    }

    get vatPlaceholderLabel(): any {
        if (this.hasNoVatFlag && this.novatRequested === 2) {
            return this.$t('Nummer der Gewerbeanmeldung/Steuernummer');
        }
        return this.$t('Enter VAT Number');
    }

    get billingAddress(): QuoteAddress {
        return checkout.billingAddress;
    }

    get vatNumberValidationRules() {
        if (this.hasNoVatFlag && this.novatRequested === 2) {
            return {
                required: true,
            };
        }
        return getValidationRules(this.addressAttributes.vat_id);
    }

    get showInvoiceText() {
        return store.state.options.payment.invoice.showText;
    }

    get invoiceText() {
        return store.state.options.payment.invoice.text;
    }

    get isLoading(): boolean {
        return cart.loadingFlags.totals || this.loading;
    }

    private validateSdi() {
        return /^[a-zA-Z0-9_.-]*$/;
    }

    private validateEmail() {
        return /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
    }

    private isItalianStore(): boolean {
        return store.state.options.store_code === 'it_it';
    }

    private mounted() {
        // If the user has SDI, PEC or VAT correctly filled out, pre-flag the checkbox only for italian store and only
        // if the selection has not been yet made, else set the flag to false
        if (this.isItalianStore() && this.requestInvoice === null) {
            this.requestInvoice =
                !!(checkout.billingAddress.extension_attributes.sdi_code ||
                    checkout.billingAddress.extension_attributes.pec ||
                    checkout.billingAddress.vat_id);

            checkout.updateRequestInvoice({
                flag: this.requestInvoice,
                params: { novatrequested: this.novatRequested }
            });
        }
    }
}
